import { EuiButton, EuiButtonEmpty } from "@inscopix/ideas-eui";
import { useState } from "react";
import { ModalCreateTool } from "./ModalCreateTool";

interface ButtonCreateToolProps {
  filled?: boolean;
  tenantKey: string;
}

export const ButtonCreateTool = ({
  tenantKey,
  filled = false,
}: ButtonCreateToolProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const Button = filled ? EuiButton : EuiButtonEmpty;

  return (
    <>
      {isModalVisible && (
        <ModalCreateTool
          tenantKey={tenantKey}
          onClose={() => setIsModalVisible(false)}
        />
      )}

      <Button
        iconType="plus"
        onClick={() => setIsModalVisible((isVisible) => !isVisible)}
      >
        Create Tool
      </Button>
    </>
  );
};
